import styled from 'styled-components'

const Style = {
	Container: styled.div`
		display: flex;
		flex-direction: column;
		gap: 8px;
		padding: 16px;
		background-color: ${({theme}) => theme.color.white};
		border: 1px solid ${({theme}) => theme.color.grey2};
		border-radius: 24px;
		width: 100%;

		@media (max-width: 768px) {
			padding: 12px;
			border-radius: 16px;
		}
	`,

	Header: styled.div`
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 24px;

		@media (max-width: 1200px) {
			flex-direction: column;
			align-items: flex-start;
			gap: 16px;
		}

		@media (max-width: 768px) {
			gap: 12px;
		}
	`,

	TitleSection: styled.div`
		display: flex;
		flex-direction: column;
		gap: 4px;
		flex: 1;
	`,

	Title: styled.h2`
		${({theme}) => theme.font.medium_bold};
		color: ${({theme}) => theme.color.black};
		margin: 0;

		@media (max-width: 768px) {
			font-size: 18px;
			line-height: 1.3;
		}
	`,

	Subtitle: styled.p`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.grey4};
		margin: 0;

		@media (max-width: 768px) {
			font-size: 11px;
			line-height: 1.2;
		}
	`,

	Dropdown: styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		border: 1px solid ${({theme}) => theme.color.grey3};
		border-radius: 4px;
		transition: all 0.2s ease;
		width: 200px;

		&:hover {
			border-color: ${({theme}) => theme.color.black};
		}

		@media (max-width: 1200px) {
			width: 100%;
			max-width: 282px;
		}

		@media (max-width: 768px) {
			width: 100%;
			padding: 6px 10px;
		}

		.react-datepicker-popper {
			width: 150px;
		}

		.react-datepicker__input-container {
			input {
				width: 100%;
				padding: 2px 0;
				text-align: center;
			}
		}

		.react-datepicker__tab-loop {
			width: 0px;
		}
	`,

	DropdownText: styled.span`
		${({theme}) => theme.font.small};
		color: ${({theme}) => theme.color.black};
	`,

	DropdownArrow: styled.div`
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;

		input[type='date'] {
			border: none;
			outline: none;
			background: transparent;
			${({theme}) => theme.font.small};
			color: ${({theme}) => theme.color.black};
			cursor: pointer;
			width: 100%;
			padding: 0;

			&::-webkit-calendar-picker-indicator {
				cursor: pointer;
				opacity: 1;
			}

			@media (max-width: 768px) {
				font-size: 12px;
			}
		}
	`,

	ButtonGroup: styled.div`
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 12px;
		width: fit-content;

		@media (max-width: 1200px) {
			width: 100%;
			justify-content: flex-end;
		}

		@media (max-width: 768px) {
			flex-direction: column;
			align-items: stretch;
			gap: 8px;
		}
	`,

	RefreshText: styled.span`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.grey4};

		@media (max-width: 768px) {
			font-size: 10px;
		}
	`,

	Button: styled.button`
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
		padding: 4px 8px;
		background-color: ${({theme}) => theme.color.white};
		border: 1px solid ${({theme}) => theme.color.black};
		border-radius: 6px;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			background-color: ${({theme}) => theme.color.grey1};
		}

		img {
			width: 16px;
			height: 16px;
		}

		@media (max-width: 768px) {
			justify-content: center;
			padding: 8px 12px;
		}
	`,

	ButtonText: styled.span`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.black};

		@media (max-width: 768px) {
			font-size: 10px;
		}
	`,

	UsageInfo: styled.div`
		display: flex;
		justify-content: flex-end;
		align-items: center;
		align-self: stretch;
		gap: 2px;
		margin-bottom: 8px;
	`,

	UsageText: styled.span`
		${({theme}) => theme.font.extra_small};
		color: ${({color}) => color};

		@media (max-width: 768px) {
			font-size: 10px;
		}
	`,

	CardsSection: styled.div`
		display: flex;
		flex-direction: row;
		align-items: stretch;
		align-self: stretch;
		gap: 16px;
		min-height: 200px;
		@media (max-width: 1200px) {
			flex-direction: column;
		}
	`,

	TotalCard: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 16px;
		width: 180px;
		align-self: stretch;

		@media (max-width: 1200px) {
			width: 100%;
			align-self: center;
		}

		@media (max-width: 768px) {
			width: 100%;
			max-width: none;
		}
	`,

	TotalCardContent: styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 4px;
		padding: 10px 24px;
		background-color: ${({theme}) => theme.color.major};
		border-radius: 12px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
		width: 100%;
		flex: 1;
	`,

	TotalCardTitle: styled.h3`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.white};
		margin: 0;
		text-align: center;

		@media (max-width: 768px) {
			font-size: 10px;
		}
	`,

	UploadIcon: styled.div`
		width: 24px;
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 24px;
			height: 24px;
		}
	`,

	TotalCardData: styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 10px;
	`,

	TotalCardValue: styled.p`
		${({theme}) => theme.font.small_bold};
		color: ${({theme}) => theme.color.white};
		text-align: center;

		@media (max-width: 768px) {
			font-size: 12px;
		}
	`,

	TournamentCards: styled.div`
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		flex: 1;
		& > * + * {
			margin-top: 16px;
		}
	`,

	TournamentCard: styled.div`
		display: flex;
		flex-direction: row;
		align-self: stretch;
		gap: 16px;
		align-items: center;
		justify-content: center;

		@media (max-width: 1200px) {
			flex-direction: column;
			align-items: stretch;
		}

		@media (max-width: 768px) {
			gap: 12px;
		}
	`,

	TournamentHeader: styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		align-self: stretch;
		gap: 8px;
		padding: 16px;
		background-color: ${({theme}) => theme.color.black};
		border-radius: 8px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
		width: 200px;

		@media (max-width: 1200px) {
			width: 100%;
		}

		@media (max-width: 768px) {
			padding: 12px;
		}
	`,

	TournamentTitle: styled.h4`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.white};
		margin: 0;
		text-align: center;

		@media (max-width: 768px) {
			font-size: 10px;
		}
	`,

	TournamentStats: styled.div`
		display: flex;
		align-items: center;
		gap: 4px;
		justify-content: center;
	`,

	StatText: styled.p`
		${({theme}) => theme.font.extra_small_bold};
		color: ${({theme}) => theme.color.white};
		text-align: center;

		@media (max-width: 768px) {
			font-size: 10px;
		}
	`,

	TournamentContent: styled.div`
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 8px;
		flex: 1;
		align-content: start;

		@media (max-width: 1200px) {
			grid-template-columns: repeat(2, 1fr);
		}

		@media (max-width: 768px) {
			grid-template-columns: 1fr;
			gap: 6px;
		}
	`,

	EventCard: styled.div`
		display: flex;
		flex-direction: column;
		gap: 2px;
		padding: 8px;
		background-color: ${({theme}) => theme.color.grey1};
		border: 1px solid ${({theme}) => theme.color.grey2};
		border-radius: 6px;
		min-width: 0;
		width: 100%;
	`,

	EventInfo: styled.div`
		display: flex;
		align-self: stretch;
		gap: 2px;
	`,

	EventName: styled.span`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.grey4};
		text-align: left;
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		@media (max-width: 768px) {
			font-size: 9px;
		}
	`,

	EventSeparator: styled.span`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.grey4};
		text-align: center;

		@media (max-width: 768px) {
			font-size: 9px;
		}
	`,

	EventStats: styled.span`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.black};
		text-align: right;
		@media (max-width: 768px) {
			font-size: 9px;
		}
	`,

	EventStatsUsed: styled.span`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.major};
		text-align: right;
		@media (max-width: 768px) {
			font-size: 9px;
		}
	`,
}

export default Style
